import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../theme/ISpcTheme';

export type MarketingLabelClasses = 'label';

const MarketingLabelStyles = makeStyles<ISpcTheme, MarketingLabelClasses>(
  theme => ({
    label: {
      fontSize: theme.typography.fontMD,
      backgroundColor: theme.palette.background.label,
      color: theme.palette.common.white,
      padding: '4px 24px',
      textAlign: 'center',

      [theme.breakpoints.down('sm')]: {
        padding: '4px 8px',
      },
    },
  }),
  { name: 'PVariants_MarketingLabel' },
);

export default MarketingLabelStyles;
